import React from "react";
import PropTypes from "prop-types";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const DonutChart = ({ data }) => (
    <ResponsiveContainer width="100%" height="100%">
        <PieChart>
            <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius="70%"
                outerRadius="100%"
                startAngle={90}
                endAngle={450}
                labelLine={false}
                stroke="none">
                {data.map((entry) => (
                    // uso entry.name (único) como key
                    <Cell key={entry.name} fill={entry.color || "#cccccc"} />
                ))}
            </Pie>
        </PieChart>
    </ResponsiveContainer>
);

DonutChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
            color: PropTypes.string, // opcional
        }),
    ).isRequired,
};

export default DonutChart;
